import store from '../store/officialTopupNew';
import { pageType } from '@plugins/biPoint/_configWebstoreV35';

const checkGameAndLogin = () => {
  return store.state.login.isLogin;
};

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      pageName: pageType.homePage
    },
    component: () => import('@views/officialTopupNew/Home.vue'),
  },
  {
    path: '/result',
    name: 'result',
    meta: {
      pageName: pageType.resultPage
    },
    component: () => import('@views/officialTopupNew/Result.vue'),
  },
  {
    path: '/mine',
    name: 'mine',
    meta: {
      pageName: pageType.Mine
    },
    component: () => import('@views/officialTopupNew/Mine.vue'),
    beforeEnter: (_to, _from, next) => {
      if (checkGameAndLogin()) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/bank_info',
    name: 'bankInfo',
    meta: {
      index: 3,
      pageName: pageType.bankPage
    },
    component: () => import('@views/officialTopupNew/BankDetailInfo.vue'),
  },
  {
    path: '/browserPay',
    name: 'browserPay',
    meta: {
      pageName: pageType.browserPay
    },
    component: () => import('@views/officialTopupNew/BrowserPaying.vue'),
  }
];
